import type { VendorOverview } from "../../types/machinesDashboard";

export function MachineKpiCards({ overview }: { overview: VendorOverview }) {
  const cards = [
    { label: "Macchine", value: overview.machinesCount },
    { label: "Online", value: overview.onlineCount },
    { label: "In allarme", value: overview.alarmCount },
    { label: "Allarmi 24h", value: overview.alarmsLast24h },
  ];

  return (
    <div className="row g-3">
      {cards.map((c) => (
        <div key={c.label} className="col-12 col-md-6 col-xl-3">
          <div className="kpi-card-machines">
            <div className="kpi-label">{c.label}</div>
            <div className="kpi-value">{c.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}